import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { USER_LOGOUT } from "../../../Redux/SagaAction/actions";
import { useDispatch } from "react-redux";
import DeleteModal from "../../../components/popup/DeleteModal";
const MobileTabs = ({ tabs }) => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [first, setFirst] = useState(0);
  const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();
  const handleToggle = () => {
    setToggle((toggle) => !toggle);
  };

  return (
    <>
      <div className="tabs sidebar">
        {tabs.map((tab, key) => {
          return (
            <>
              <div className={!toggle === true ? "is-active" : null} key={key}>
                <div
                  className="custom-li"
                  onClick={() => {
                    navigate(tab?.path);
                    setFirst(tab?.id);
                    handleToggle();
                    if (tab?.id === 6) {
                      setShow(true);
                    }
                  }}
                >
                  <input type="radio" name="tabs" id={tab?.id} />
                  {tab?.icon}
                  <label htmlFor={tab?.id}>{tab?.title}</label>
                </div>
                {tab?.id === first && <div className="tab">{tab?.content}</div>}
              </div>
              {show && (
                <DeleteModal
                  logout
                  showDeleteModal={show}
                  setshowDeleteModal={setShow}
                  // deleteId={deleteId}
                />
              )}
            </>
          );
        })}
      </div>
    </>
  );
};

export default MobileTabs;

// import { NavLink, Route, Routes, Outlet } from 'react-router-dom'

// const MobileTabs = ({  tabs, handleTabChange }) => {

//     return (

/* <nav>
                {tabs.map((tab) => (

                    <NavLink
                        key={tab.id}
                        to={tab.path}
                        isActive={() => activeTab === tab.path}
                        onClick={() => handleTabChange(tab.path)}
                        onOverflow={'scroll'}
                        style={{ color: 'white',backgroundColor:"#e83647",margin:"10px",padding:"5px" }}
                    >
                        {tab.title}
                    </NavLink>

                ))}
                <div className="tab-content">
                    <Outlet />
                </div>
            </nav> */

//     )
//         }
// export default MobileTabs
